import React, { Component } from 'react'
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import classes from './VideoPlayerControls.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faForward, faBackward } from '@fortawesome/free-solid-svg-icons';

import PH from 'Flow2/util/MetadataPermissionHelper.js';
import * as Controls from 'Flow2/config/Controls';


const mapStateToProps = (state, ownProps) => {
	return {
		config: state.ui.config,
		stepSeconds: state.ui.config.PLAYER_STEP_SECONDS || 10
	}
}

const forward = (props) => {
		if(!PH.showControl(props.config, Controls.CTL_PLAYER_SKIP_FORWARD)) return "";
		
		const onForward = () => {
			const newTime = props.video.currentTime + props.stepSeconds;
			props.video.currentTime = newTime;
		}
		
		return (
			<div className={[classes.SkipForward, classes.Icon, 'pointer'].join(' ')} >
				<FontAwesomeIcon onClick={onForward} icon={faForward} title={props.intl.formatMessage({ id: "videoplayer.step.forward" }, { seconds: props.stepSeconds })} />
			</div>
		);
	}
	
export const SkipForward = connect(mapStateToProps)(injectIntl(forward));

const backward = (props) => {
		if(!PH.showControl(props.config, Controls.CTL_PLAYER_SKIP_BACKWARD)) return "";
		
		const onBackward = () => {
			const newTime = props.video.currentTime - props.stepSeconds;
			props.video.currentTime = (newTime < 0) ? 0 : newTime;
		}
		
		return (
			<div className={[classes.SkipBackward, classes.Icon, 'pointer'].join(' ')} >
				<FontAwesomeIcon onClick={onBackward} icon={faBackward} title={props.intl.formatMessage({ id: "videoplayer.step.backward" }, { seconds: props.stepSeconds })} />
			</div>
		);
	}

export const SkipBackward = connect(mapStateToProps)(injectIntl(backward));


